(() => {
  function init(scope) {
    scope.querySelectorAll('[data-s2t-contact]').forEach(root => {
      if (root.dataset.contactReady) return;
      root.dataset.contactReady = 'true';
      const directions = root.querySelector('[data-s2t-contact-directions]');
      // iPadOS can identify as a Mac when requesting the desktop site.
      const platform = navigator.userAgentData?.platform || navigator.platform || '';
      if (directions && /Mac|iPhone|iPad|iPod/i.test(platform + ' ' + navigator.userAgent)) {
        directions.href = directions.dataset.appleMaps;
      }
      const trigger = root.querySelector('[data-s2t-contact-chat]');
      const status = root.querySelector('[data-s2t-contact-chat-status]');
      if (trigger) trigger.addEventListener('click', event => {
        event.preventDefault();
        if (trigger.getAttribute('aria-busy') === 'true') return;
        trigger.setAttribute('aria-busy', 'true');
        status.hidden = true;
        let attempts = 0;
        function openChat() {
          if (!root.isConnected) return;
          const chat = document.querySelector('shopify-chat');
          // Shopify's component API survives the launcher's runtime/shadow-DOM replacement.
          if (chat && typeof chat.show === 'function') {
            try { chat.show(); trigger.removeAttribute('aria-busy'); return; }
            catch (error) { /* Show the contact alternatives below if the provider cannot open. */ }
          }
          if (++attempts < 20) { window.setTimeout(openChat, 150); return; }
          trigger.removeAttribute('aria-busy');
          status.hidden = false;
        }
        openChat();
      });
      const open = root.querySelector('[data-s2t-contact-form-open]');
      const dialog = root.querySelector('[data-s2t-contact-dialog]');
      const close = root.querySelector('[data-s2t-contact-form-close]');
      const frame = root.querySelector('[data-s2t-contact-form-frame]');
      const loading = root.querySelector('[data-s2t-contact-form-loading]');
      if (!open || !dialog || typeof dialog.showModal !== 'function') return;
      open.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        document.documentElement.classList.add('s2t-contact-modal-open');
        if (!frame.hasAttribute('src')) {
          frame.addEventListener('load', () => { loading.hidden = true; }, { once: true });
          frame.src = frame.dataset.src;
          window.setTimeout(() => { loading.hidden = true; }, 10000);
        }
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('s2t-contact-modal-open');
        open.focus({ preventScroll: true });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
